import PropTypes from 'prop-types';
import React from 'react';
import { DEFAULT_HELP_POPUP_TITLE, getUserErrorMessage } from '../../constants/error';
import { HTTP_RESPONSE_CODE } from '../../constants/http';
import HelpPopup from '../components/helpPopup/HelpPopup';
import RetryButton from './RetryButton';
import LogoutButton from './LogoutButton';

const shouldRenderLayout = ({ screenLevelErrorStatusCode }) =>
    screenLevelErrorStatusCode !== undefined;

const getButtons = props => {
    const buttons = [<RetryButton key="retryButton-1" onClick={props.onRetry} isPrimary />];

    if (
        [HTTP_RESPONSE_CODE.GATEWAY_TIMEOUT, HTTP_RESPONSE_CODE.SERVER_ERROR].includes(
            props.screenLevelErrorStatusCode,
        )
    ) {
        buttons.push(
            <LogoutButton key="screenLevelError-logoutButton" onClick={props.logUserOut} />,
        );
    }

    return buttons;
};

const ScreenErrorView = props =>
    shouldRenderLayout(props) && (
        <div className="retry-layout">
            <HelpPopup
                title={DEFAULT_HELP_POPUP_TITLE}
                problem={getUserErrorMessage(props.screenLevelErrorStatusCode)}
                buttons={getButtons(props)}
            />
        </div>
    );

ScreenErrorView.propTypes = {
    screenLevelErrorStatusCode: PropTypes.number,
};

ScreenErrorView.defaultProps = {
    screenLevelErrorStatusCode: undefined,
};

export default ScreenErrorView;
